var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-orders" },
    [
      _vm.showTooltipTaxHint && !_vm.isSelectedAnyTaxes
        ? _c(
            "b-tooltip",
            {
              attrs: {
                show: _vm.showTooltipTaxHint,
                triggers: "hover focus blur",
                target: "tooltip-tax-hint-1",
                placement: "top"
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("message.pickwhthere")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-none d-md-flex mb-2",
          staticStyle: { overflow: "hidden", height: "21px" }
        },
        [
          _c("div", { staticClass: "col-sku" }, [
            _c("strong", { staticClass: "text-secondary-light" }, [
              _vm._v(_vm._s(_vm.$t("message.productorservice")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-detail" }, [
            _c("strong", { staticClass: "text-secondary-light" }, [
              _vm._v(_vm._s(_vm.$t("message.description")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-qty text-right" }, [
            _c("strong", { staticClass: "text-secondary-light" }, [
              _vm._v(_vm._s(_vm.$t("message.quantity")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-price text-right" }, [
            _c("strong", { staticClass: "text-secondary-light" }, [
              _vm._v(_vm._s(_vm.$t("message.price")))
            ])
          ]),
          _vm._v(" "),
          !_vm.hideFields.includes("discount")
            ? _c("div", { staticClass: "col-discount text-right" }, [
                _c("strong", { staticClass: "text-secondary-light" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.discount")) +
                      "\n      "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideFields.includes("tax")
            ? _c("div", { staticClass: "col-tax text-right" }, [
                _c("strong", { staticClass: "text-secondary-light" }, [
                  _vm._v(_vm._s(_vm.$t("message.taxes")))
                ]),
                _vm._v(" "),
                _c("i", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.hover.top",
                      value: _vm.$t("message.advisetosetuptax"),
                      expression: "$t('message.advisetosetuptax')",
                      modifiers: { hover: true, top: true }
                    }
                  ],
                  staticClass: "fas fa-info-circle text-secondary-light",
                  attrs: { title: _vm.$t("message.advise") }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-subtotal text-right" }, [
            _c("strong", { staticClass: "text-secondary-light" }, [
              _vm._v(_vm._s(_vm.$t("message.subtotal")))
            ])
          ]),
          _vm._v(" "),
          !_vm.disabled ? _c("div", { staticClass: "col-delete" }) : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.data, function(item, index) {
        return _vm.ready
          ? _c(
              "div",
              {
                staticClass: "d-flex flex-column flex-md-row form-order",
                on: {
                  click: function($event) {
                    return _vm.clickAtSingleList(index)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-sku mb-2",
                    staticStyle: { height: "38px" }
                  },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        { staticStyle: { flex: "1" } },
                        [
                          _vm.show_selectize[index] == true
                            ? [
                                !_vm.disabled
                                  ? _c("vue-bootstrap-autocomplete", {
                                      attrs: {
                                        data: (function() {
                                          return !item.sku_id &&
                                            !item.is_saving_product
                                            ? [
                                                {
                                                  text: "",
                                                  sku_code: "",
                                                  value: ""
                                                }
                                              ].concat(_vm.optionSkus)
                                            : []
                                        })(),
                                        serializer: function(item) {
                                          return (
                                            item.text +
                                            " " +
                                            (item.sku_code || "")
                                          )
                                        },
                                        minMatchingChars: 1,
                                        maxMatches: 10,
                                        placeholder: _vm.createAble
                                          ? _vm.$t("placeholder.selectorcreate")
                                          : _vm.$t("placeholder.selectitem"),
                                        loading: item.selectize.loading,
                                        state: (function() {
                                          if (
                                            item.selectize.trickValidation > 0
                                          ) {
                                            return !item.sku_id ? false : null
                                          } else {
                                            return null
                                          }
                                        })(),
                                        disabled: item.is_saving_product
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.data[
                                            index
                                          ].selectize.loading = true
                                          _vm.lookupProducts(index, $event)
                                        },
                                        hit: function($event) {
                                          return _vm.handleSelectProduct(
                                            index,
                                            $event
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.handleBlurProduct(
                                            index,
                                            $event
                                          )
                                        },
                                        inputBlur: function($event) {
                                          return _vm.handleInputBlurProduct(
                                            index,
                                            $event
                                          )
                                        },
                                        keydown: function($event) {
                                          return _vm.handleKeydownProduct(
                                            index,
                                            $event
                                          )
                                        },
                                        keyup: function($event) {
                                          return _vm.handleKeyupProduct(
                                            index,
                                            $event
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "create",
                                            fn: function(ref) {
                                              var data = ref.data
                                              var htmlText = ref.htmlText
                                              return item.queryProductName
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          cursor: "pointer"
                                                        },
                                                        on: {
                                                          mousedown: function(
                                                            $event
                                                          ) {
                                                            return _vm.onAddedSku(
                                                              item.queryProductName
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-success"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-plus"
                                                            }),
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "message.addnewproduct"
                                                                  )
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#8f9295"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  item.queryProductName
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : undefined
                                            }
                                          },
                                          {
                                            key: "suggestion",
                                            fn: function(ref) {
                                              var data = ref.data
                                              var htmlText = ref.htmlText
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center"
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "40px",
                                                        height: "40px",
                                                        "border-radius":
                                                          "0.25rem"
                                                      },
                                                      attrs: {
                                                        src: _vm.productImage(
                                                          data.value
                                                        )
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-column"
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass: "ml-4",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              data.text
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass: "ml-4",
                                                          staticStyle: {
                                                            "font-size": "11px"
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              data.sku_code
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.queryProductName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "queryProductName",
                                            $$v
                                          )
                                        },
                                        expression: "item.queryProductName"
                                      }
                                    })
                                  : _c("input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        disabled: _vm.disabled,
                                        type: "text"
                                      },
                                      domProps: {
                                        value: _vm.getSku(item.sku_id)
                                          ? _vm.getSku(item.sku_id).product_name
                                          : null
                                      }
                                    })
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-detail mb-3" },
                  [
                    _c("b-form-textarea", {
                      attrs: {
                        disabled: item.sku_id.length == 0 || _vm.disabled,
                        placeholder: _vm.$t("placeholder.description"),
                        noResize: true,
                        maxRows: 1
                      },
                      model: {
                        value: item.description,
                        callback: function($$v) {
                          _vm.$set(item, "description", $$v)
                        },
                        expression: "item.description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-qty mb-2",
                    staticStyle: { position: "relative" }
                  },
                  [
                    _c("BaseInputGroupMobile", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("message.quantity")) +
                                    "\n        "
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "input",
                            fn: function() {
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.quantity,
                                      expression: "item.quantity"
                                    }
                                  ],
                                  ref: "input-qty-" + index,
                                  refInFor: true,
                                  staticClass:
                                    "form-control text-right text-select-all quantity",
                                  attrs: {
                                    disabled:
                                      item.sku_id.length == 0 || _vm.disabled,
                                    type: "text",
                                    placeholder: ""
                                  },
                                  domProps: { value: item.quantity },
                                  on: {
                                    keypress: _vm.numberOnly,
                                    keyup: function($event) {
                                      item.quantity = _vm.setToValidNumber(
                                        item.quantity
                                      )
                                    },
                                    focus: function($event) {
                                      return _vm.handleInputQtyFocus(
                                        item,
                                        index
                                      )
                                    },
                                    blur: function($event) {
                                      _vm.handleInputQtyBlur(item, index)
                                      item.quantity = _vm.setToCustomDigitsNumber(
                                        item.quantity
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item,
                                        "quantity",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    item.sku_id.length > 0 &&
                    !_vm.disabled &&
                    _vm.getSkuInfoBySkuId(item.sku_id)
                      ? _c(
                          "div",
                          {
                            ref: "modal-current-stock-" + index,
                            refInFor: true,
                            staticClass: "modal-current-stock"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "container p-0" },
                              _vm._l(
                                _vm.getSkuInfoBySkuId(item.sku_id).stocks,
                                function(stock, index_) {
                                  return _vm.getWarehouseInfo(
                                    stock.warehouse_id
                                  )
                                    ? _c(
                                        "section",
                                        { staticClass: "row mb-1" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-12" },
                                            [
                                              _c("section-title", {
                                                attrs: {
                                                  title: _vm.getWarehouseInfo(
                                                    stock.warehouse_id
                                                  ).warehouse_name,
                                                  fontweight: "bold"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-12" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group mb-2"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group-prepend"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-text",
                                                                  staticStyle: {
                                                                    "min-width":
                                                                      "90px"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "apps.inventory.message.instock"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            staticClass:
                                                              "form-control form-control-sm text-right",
                                                            attrs: {
                                                              type: "text",
                                                              disabled: ""
                                                            },
                                                            domProps: {
                                                              value:
                                                                stock.instock
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group mb-2"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group-prepend"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-text",
                                                                  staticStyle: {
                                                                    "min-width":
                                                                      "90px"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "apps.inventory.message.reserved"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            staticClass:
                                                              "form-control form-control-sm text-right",
                                                            attrs: {
                                                              type: "text",
                                                              disabled: ""
                                                            },
                                                            domProps: {
                                                              value:
                                                                stock.reserved
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                }
                              ),
                              0
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-price mb-2" },
                  [
                    _c("BaseInputGroupMobile", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("message.price")) +
                                    "\n        "
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "input",
                            fn: function() {
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.price,
                                      expression: "item.price"
                                    }
                                  ],
                                  staticClass:
                                    "form-control text-right text-select-all",
                                  attrs: {
                                    disabled:
                                      item.sku_id.length == 0 || _vm.disabled,
                                    type: "text",
                                    placeholder: ""
                                  },
                                  domProps: { value: item.price },
                                  on: {
                                    keypress: _vm.numberOnly,
                                    keyup: function($event) {
                                      item.price = _vm.setToValidNumber(
                                        item.price
                                      )
                                    },
                                    blur: function($event) {
                                      item.price = _vm.setToCustomDigitsNumber(
                                        item.price
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item,
                                        "price",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.hideFields.includes("discount")
                  ? _c("div", { staticClass: "col-discount mb-2" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "input-group-prepend d-flex d-md-none"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "input-group-text",
                                staticStyle: { "min-width": "80px" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("message.discount")) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.discounts[0].value_amount,
                              expression: "item.discounts[0].value_amount"
                            }
                          ],
                          staticClass:
                            "form-control text-right text-select-all",
                          staticStyle: {
                            "border-right": "none",
                            padding: "0 8px 0 0"
                          },
                          attrs: {
                            disabled: item.sku_id.length == 0 || _vm.disabled,
                            type: "text"
                          },
                          domProps: { value: item.discounts[0].value_amount },
                          on: {
                            keypress: _vm.numberOnly,
                            keyup: function($event) {
                              item.discounts[0].value_amount = _vm.setToValidNumber(
                                item.discounts[0].value_amount
                              )
                            },
                            focus: function($event) {
                              _vm.isFocusInputDiscount = true
                              _vm.clickAtSingleList(index)
                            },
                            blur: function($event) {
                              _vm.isFocusInputDiscount = false
                              item.discounts[0].value_amount = _vm.setToCustomDigitsNumber(
                                item.discounts[0].value_amount
                              )
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                item.discounts[0],
                                "value_amount",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-discount",
                              class: [
                                {
                                  "btn-web":
                                    _vm.isFocusInputDiscount &&
                                    _vm.focusAtIndex == index &&
                                    _vm.isReadyToEditDiscount
                                }
                              ],
                              staticStyle: { opacity: "1 !important" },
                              attrs: {
                                disabled:
                                  item.sku_id.length == 0 || _vm.disabled,
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              },
                              on: {
                                focus: function($event) {
                                  _vm.isFocusInputDiscount = true
                                },
                                blur: function($event) {
                                  _vm.isFocusInputDiscount = false
                                },
                                click: function($event) {
                                  _vm.isFocusInputDiscount = true
                                  _vm.clickAtSingleList(index)
                                }
                              }
                            },
                            [
                              item.discounts[0].value_type == "percentage"
                                ? _c("span", [
                                    _vm._v("\n              %\n              "),
                                    _vm.isFocusInputDiscount &&
                                    _vm.focusAtIndex == index &&
                                    _vm.isReadyToEditDiscount
                                      ? _c("i", {
                                          staticClass: "fas fa-caret-down"
                                        })
                                      : _vm._e()
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.currency) +
                                        "\n              "
                                    ),
                                    _vm.isFocusInputDiscount &&
                                    _vm.focusAtIndex == index &&
                                    _vm.isReadyToEditDiscount
                                      ? _c("i", {
                                          staticClass: "fas fa-caret-down"
                                        })
                                      : _vm._e()
                                  ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function($event) {
                                      item.discounts[0].value_type =
                                        "percentage"
                                    }
                                  }
                                },
                                [_vm._v("%")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function($event) {
                                      item.discounts[0].value_type = "number"
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.currency))]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.hideFields.includes("tax")
                  ? _c(
                      "div",
                      {
                        staticClass: "col-tax mb-2",
                        attrs: { id: "tooltip-tax-hint-" + (index + 1) }
                      },
                      [
                        _c("BaseInputGroupMobile", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(_vm.$t("message.taxes")) +
                                        "\n        "
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "input",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "flex-grow-1" },
                                      [
                                        _c("MultipleSelect", {
                                          attrs: {
                                            options: _vm.taxOptions,
                                            multiple: true,
                                            disabled:
                                              item.sku_id.length == 0 ||
                                              _vm.disabled
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.handleChangeTax(
                                                $event,
                                                index
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.selectedTaxIds,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "selectedTaxIds",
                                                $$v
                                              )
                                            },
                                            expression: "item.selectedTaxIds"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-subtotal mb-2" },
                  [
                    _c("BaseInputGroupMobile", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("message.subtotal")) +
                                    "\n        "
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "input",
                            fn: function() {
                              return [
                                _c("BaseInputNumber", {
                                  staticClass: "form-control text-right",
                                  attrs: {
                                    value: _vm.getOrderTotal(item),
                                    type: "text",
                                    disabled: "",
                                    placeholder: ""
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.disabled
                  ? _c("div", { staticClass: "col-delete mb-2 text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn col-12",
                          on: {
                            click: function($event) {
                              return _vm.del(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "far fa-trash-alt" })]
                      )
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      !_vm.disabled
        ? _c("section", { staticClass: "mb-3" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.add()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("button.addproduct")))]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-559a1720", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-559a1720","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/Order.vue
// module id = null
// module chunks = 